import toast from 'react-hot-toast'

import http from '../../lib/http'
import { queryClient } from '../../lib/query-client.ts'

export const GET_ALERTS = 'alerts/GET_ALERTS'
export const GET_ALERTS_SUCCESS = 'alerts/GET_ALERTS_SUCCESS'
export const GET_ALERTS_FAIL = 'alerts/GET_ALERTS_FAIL'

export const OWN_ALERT = 'alerts/OWN_ALERT'
export const OWN_ALERT_SUCCESS = 'alerts/OWN_ALERT_SUCCESS'
export const OWN_ALERT_FAIL = 'alerts/OWN_ALERT_FAIL'

export const GET_CARETEAM = 'alerts/GET_CARETEAM'
export const GET_CARETEAM_SUCCESS = 'alerts/GET_CARETEAM_SUCCESS'
export const GET_CARETEAM_FAIL = 'alerts/GET_CARETEAM_FAIL'

export const SHOW_CARETEAM_MODAL = 'alerts/SHOW_CARETEAM_MODAL'
export const HIDE_CARETEAM_MODAL = 'alerts/HIDE_CARETEAM_MODAL'

export function showModal () {
  return dispatch => dispatch({ type: SHOW_CARETEAM_MODAL })
}

export function hideModal () {
  return dispatch => dispatch({ type: HIDE_CARETEAM_MODAL })
}

export function getCareteam (careteam) {
  return dispatch => {
    dispatch({ type: GET_CARETEAM })
    dispatch({
      type: GET_CARETEAM_SUCCESS,
      results: careteam
    })
    dispatch(showModal())
  }
}

export function ownAlert (id) {
  const url = `/alerts/${id}/own`
  return http
    .postRequest(url, {})
    .then(() => {
      toast.success('Symptom alert owned successfully', { position: 'bottom-center' })
    })
    .then(async () => {
      await queryClient.invalidateQueries({ queryKey: [ 'alerts' ] })
    })
}

export function escalateAlert (id) {
  const url = `/alerts/${id}/escalate`
  return http
    .postRequest(url, {})
    .then(async () => {
      await queryClient.invalidateQueries({ queryKey: [ 'alerts' ] })
    })
}
